import { createFileRoute } from '@tanstack/react-router'
import { EntityTypeFieldsTab } from '@admin/preferences/entities/EntityTypeFieldsTab'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/fields')({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()
  return <EntityTypeFieldsTab entityType={entityType} />
}
